import Vue from "vue";
import axios from "axios";
import { backend_url } from "../../utils/config.js";

const state = {
  status: "",
  profile: {},
  userList: [],
};

const getters = {
  getProfile: (state) => state.profile,
  isProfileLoaded: (state) => !!state.profile._id,
  getUserList: (state) => state.userList,
};

const actions = {
  USER_REQUEST: ({ commit, dispatch }, token) => {
    return new Promise(async (resolve, reject) => {
      commit("USER_REQUEST");
      if (token) {
        axios
          .get(`${backend_url}/auth/verifyauthentication`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(({ data }) => {
            commit("USER_SUCCESS", data);
            commit("AUTH_SUCCESS", token);
            resolve(data);
          })
          .catch(() => {
            commit("USER_ERROR");
            dispatch("AUTH_LOGOUT");
            reject({ info: "Invalid token" });
          });
      } else {
        commit("USER_ERROR");
        dispatch("AUTH_LOGOUT");
        reject({ info: "No token" });
      }
    });
  },
  USERSLIST_REQUEST: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`${backend_url}/user`);
        commit("GET_USERSLIST", data);
        resolve(data);
      } catch (err) {
        commit("USERSLIST_ERROR");
        reject(err);
      }
    });
  },
  ADD_USER: ({ commit }, user) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post(`${backend_url}/auth/signup`, user);
        resolve(data);
      } catch (err) {
        commit("USERSLIST_ERROR");
        reject(err);
      }
    });
  },
};

const mutations = {
  USER_REQUEST: (state) => {
    state.status = "loading";
  },
  USER_SUCCESS: (state, resp) => {
    state.status = "success";
    Vue.set(state, "profile", resp);
  },
  USER_ERROR: (state) => {
    state.status = "error";
  },
  AUTH_LOGOUT: (state) => {
    state.profile = {};
  },
  GET_USERSLIST: (state, users) => {
    state.userList = users;
  },
  USERSLIST_ERROR: (state) => {
    state.userList = [];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
